var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"succ-content"},[_c('svg-icon',{staticClass:"succ-featured",attrs:{"icon":"ic-nodata-mini","width":"130","height":"100"}}),_c('div',{staticClass:"succ-content mb-8"},[_vm._v(_vm._s(_vm.$t('data_not_available')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }